// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"7e1ae9ee","787":"b363f5e5"}[chunkId] + ".chunk.js";
};